import apiFetch from '../api/apiFetch.js'
/**
 * Created by PanJiaChen on 16/11/18.
 */

/**
 * 设置 cookie 值的函数
 * @param cname
 * @param cvalue
 * @param exdays
 */
export function setCookie (cname, cvalue, exdays) {
  var d = new Date()
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000))
  var expires = 'expires=' + d.toGMTString()
  document.cookie = cname + '=' + cvalue + '; ' + expires
}

/**
 * 获取 cookie 值的函数
 * @param cname
 * @returns {string}
 */

export function getCookie (cname) {
  var name = cname + '='
  var ca = document.cookie.split(';')
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i].trim()
    if (c.indexOf(name) == 0) return c.substring(name.length, c.length)
  }
  return ''
}

/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string | null}
 */
export function parseTime (time, cFormat) {
  if (arguments.length === 0 || !time) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if ((typeof time === 'string')) {
      if ((/^[0-9]+$/.test(time))) {
        // support "1548221490638"
        time = parseInt(time)
      } else {
        // support safari
        // https://stackoverflow.com/questions/4310953/invalid-date-in-safari
        time = time.replace(new RegExp(/-/gm), '/')
      }
    }

    if ((typeof time === 'number') && (time.toString().length === 10)) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
    const value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value ] }
    return value.toString().padStart(2, '0')
  })
  return time_str
}

export function formatHourMinute (time) {
  if (!time) {
    return ''
  }

  const match = String(time).match(/^(\d{1,2}):(\d{2})(?::\d{2})?$/)
  return match ? `${match[1].padStart(2, '0')}:${match[2]}` : ''
}

export  function formatDateTime(date, format) {
  if (!date){
    return ''
  }
  // 统一转换为Date对象
  const d = new Date(date);
  
  // 检查日期是否有效
  if (isNaN(d.getTime())) {
    return ''
    // throw new Error('无效的日期参数');
  }

  // 获取各时间部分
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  const hours = String(d.getHours()).padStart(2, '0');
  const minutes = String(d.getMinutes()).padStart(2, '0');
  const seconds = String(d.getSeconds()).padStart(2, '0');

  // 替换模板中的占位符
  return format
    .replace('yyyy', year)
    .replace('mm', month)
    .replace('dd', day)
    .replace('HH', hours)
    .replace('MM', minutes)
    .replace('ss', seconds);
}
export function getWeekDay(date, lang = 'short') {
  const d = new Date(date);
  
  // 检查日期是否有效
  if (isNaN(d.getTime())) {
    return ''
    // throw new Error('无效的日期参数');
  }

  const dayIndex = d.getDay(); // 0=周日, 1=周一, ...

  const weekMap = {
    zh: ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'],
    en: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    short: ['周日', '周一', '周二', '周三', '周四', '周五', '周六']
  };

  return weekMap[lang]?.[dayIndex] || weekMap.zh[dayIndex];
}
export function isWeekend(date) {
  const d = new Date(date);
  const dayIndex = d.getDay();

  return !isNaN(d.getTime()) && (dayIndex === 0 || dayIndex === 6);
}
/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
export function formatTime (time, option) {
  if (('' + time).length === 10) {
    time = parseInt(time) * 1000
  } else {
    time = +time
  }
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return (
      d.getMonth() +
      1 +
      '月' +
      d.getDate() +
      '日' +
      d.getHours() +
      '时' +
      d.getMinutes() +
      '分'
    )
  }
}

/**
 * 计算两个日期之间的天数差
 * @param {string|Date} date1 - 开始日期
 * @param {string|Date} date2 - 结束日期
 * @returns {number} 天数差
 */
export function calculateDays(date1, date2) {
    // 转换为Date对象
    const d1 = typeof date1 === 'string' ? new Date(date1) : date1;
    const d2 = typeof date2 === 'string' ? new Date(date2) : date2;
    
    // 检查日期是否有效
    if (isNaN(d1.getTime()) || isNaN(d2.getTime())) {
        throw new Error('Invalid date format');
    }
    
    // 计算时间差（毫秒）
    const timeDiff = d2.getTime() - d1.getTime();
    
    // 转换为天数
    const daysDiff = timeDiff / (1000 * 60 * 60 * 24);
    
    // 返回绝对值或实际值
    return Math.abs(daysDiff);
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function getQueryObject (url) {
  url = url == null ? window.location.href : url
  const search = url.substring(url.lastIndexOf('?') + 1)
  const obj = {}
  const reg = /([^?&=]+)=([^?&=]*)/g
  search.replace(reg, (rs, $1, $2) => {
    const name = decodeURIComponent($1)
    let val = decodeURIComponent($2)
    val = String(val)
    obj[name] = val
    return rs
  })
  return obj
}

/**
 * @param {string} input value
 * @returns {number} output value
 */
export function byteLength (str) {
  // returns the byte length of an utf8 string
  let s = str.length
  for (var i = str.length - 1; i >= 0; i--) {
    const code = str.charCodeAt(i)
    if (code > 0x7f && code <= 0x7ff) s++
    else if (code > 0x7ff && code <= 0xffff) s += 2
    if (code >= 0xDC00 && code <= 0xDFFF) i--
  }
  return s
}

/**
 * @param {Array} actual
 * @returns {Array}
 */
export function cleanArray (actual) {
  const newArray = []
  for (let i = 0; i < actual.length; i++) {
    if (actual[i]) {
      newArray.push(actual[i])
    }
  }
  return newArray
}

/**
 * @param {Object} json
 * @returns {Array}
 */
export function param (json) {
  if (!json) return ''
  return cleanArray(
    Object.keys(json).map(key => {
      if (json[key] === undefined) return ''
      return encodeURIComponent(key) + '=' + encodeURIComponent(json[key])
    })
  ).join('&')
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function param2Obj (url) {
  const search = decodeURIComponent(url.split('?')[1]).replace(/\+/g, ' ')
  if (!search) {
    return {}
  }
  const obj = {}
  const searchArr = search.split('&')
  searchArr.forEach(v => {
    const index = v.indexOf('=')
    if (index !== -1) {
      const name = v.substring(0, index)
      const val = v.substring(index + 1, v.length)
      obj[name] = val
    }
  })
  return obj
}

/**
 * @param {string} val
 * @returns {string}
 */
export function html2Text (val) {
  const div = document.createElement('div')
  div.innerHTML = val
  return div.textContent || div.innerText
}

/**
 * Merges two objects, giving the last one precedence
 * @param {Object} target
 * @param {(Object|Array)} source
 * @returns {Object}
 */
export function objectMerge (target, source) {
  if (typeof target !== 'object') {
    target = {}
  }
  if (Array.isArray(source)) {
    return source.slice()
  }
  Object.keys(source).forEach(property => {
    const sourceProperty = source[property]
    if (typeof sourceProperty === 'object') {
      target[property] = objectMerge(target[property], sourceProperty)
    } else {
      target[property] = sourceProperty
    }
  })
  return target
}

/**
 * @param {HTMLElement} element
 * @param {string} className
 */
export function toggleClass (element, className) {
  if (!element || !className) {
    return
  }
  let classString = element.className
  const nameIndex = classString.indexOf(className)
  if (nameIndex === -1) {
    classString += '' + className
  } else {
    classString =
      classString.substr(0, nameIndex) +
      classString.substr(nameIndex + className.length)
  }
  element.className = classString
}

/**
 * @param {string} type
 * @returns {Date}
 */
export function getTime (type) {
  if (type === 'start') {
    return new Date().getTime() - 3600 * 1000 * 24 * 90
  } else {
    return new Date(new Date().toDateString())
  }
}

/**
 * @param {Function} func
 * @param {number} wait
 * @param {boolean} immediate
 * @return {*}
 */
export function debounce (func, wait, immediate) {
  let timeout, args, context, timestamp, result

  const later = function () {
    // 据上一次触发时间间隔
    const last = +new Date() - timestamp

    // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last)
    } else {
      timeout = null
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args)
        if (!timeout) context = args = null
      }
    }
  }

  return function (...args) {
    context = this
    timestamp = +new Date()
    const callNow = immediate && !timeout
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(later, wait)
    if (callNow) {
      result = func.apply(context, args)
      context = args = null
    }

    return result
  }
}

/**
 * This is just a simple version of deep copy
 * Has a lot of edge cases bug
 * If you want to use a perfect deep copy, use lodash's _.cloneDeep
 * @param {Object} source
 * @returns {Object}
 */
export function deepClone (source) {
  if (!source && typeof source !== 'object') {
    throw new Error('error arguments', 'deepClone')
  }
  const targetObj = source.constructor === Array ? [] : {}
  Object.keys(source).forEach(keys => {
    if (source[keys] && typeof source[keys] === 'object') {
      targetObj[keys] = deepClone(source[keys])
    } else {
      targetObj[keys] = source[keys]
    }
  })
  return targetObj
}

/**
 * @param {Array} arr
 * @returns {Array}
 */
export function uniqueArr (arr) {
  return Array.from(new Set(arr))
}

/**
 * @returns {string}
 */
export function createUniqueString () {
  const timestamp = +new Date() + ''
  const randomNum = parseInt((1 + Math.random()) * 65536) + ''
  return (+(randomNum + timestamp)).toString(32)
}

/**
 * Check if an element has a class
 * @param {HTMLElement} elm
 * @param {string} cls
 * @returns {boolean}
 */
export function hasClass (ele, cls) {
  return !!ele.className.match(new RegExp('(\\s|^)' + cls + '(\\s|$)'))
}

/**
 * Add class to element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
export function addClass (ele, cls) {
  if (!hasClass(ele, cls)) ele.className += ' ' + cls
}

/**
 * Remove class from element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
export function removeClass (ele, cls) {
  if (hasClass(ele, cls)) {
    const reg = new RegExp('(\\s|^)' + cls + '(\\s|$)')
    ele.className = ele.className.replace(reg, ' ')
  }
}

// 获取、本周日期 week、 范围month
export function getDateRange (type) {
  console.log(type)
  const today = new Date()
  const YY = today.getFullYear() // 年
  const MM = today.getMonth() + 1 // 月
  const DD = today.getDate() // 日
  const hh = today.getHours() // 小时
  const mm = today.getMinutes() // 分钟
  const ss = today.getSeconds() // 秒
  const todayDate = `${YY}-${MM}-${DD}`
  console.log(todayDate)
  let startDate
  if (type === 'week') {
    startDate = `${getTheDay(todayDate)} 00:00:00`
  }
  if (type === 'month') {
    startDate = `${YY}-${MM}-01 00:00:00`
  }
  // const startDate = `${this.getTheDay(todayDate)} 00:00:00`
  // const enDate = `${todayDate} ${hh}:${mm}:${ss}`
  const enDate = `${todayDate} 23:59:59`
  const obj = { startDate, enDate }
  // console.log(obj)
  return obj
}
// 获取、本周一日期
export function getTheDay (strTime) {
  // 将获取的字符转转换为 new date
  const date = new Date(Date.parse(strTime.replace(/-/g, '/')))
  // 获取该天是周几
  const datnum = date.getDay()
  // 调用addDay方法获取本周一new date
  console.log(date.getTime())
  const getdays = addDay(-datnum + 1, date)
  console.log(getdays.getDay())
  // 将得到的new date转换为时间
  const getday = getdays.getFullYear() + '-' + (getdays.getMonth() + 1) + '-' + getdays.getDate()
  return getday
}
// 方法 增添dayNumber天（整形），date：如果没传就使用今天（日期型）
export function addDay (dayNumber, date) {
  date = date || new Date()
  const ms = dayNumber * (1000 * 60 * 60 * 24)
  const newDate = new Date(date.getTime() + ms)
  return newDate
}

// 获取字典数据
export async function getDictionariesCom (dictionaries) {
  const sessionObj = JSON.parse(sessionStorage.getItem('dictionaries'))
  // debugger
  const tempDictionaries = Object.assign(dictionaries, sessionObj)
  // console.log(tempDictionaries)
  for (const type in tempDictionaries) {
    if (tempDictionaries[type].length > 0) {
      continue
    } else {
      const params = { groupId: type }
      await apiFetch.dictionaries(params).then((res) => {
        tempDictionaries[type] = res.data
        // console.log(tempDictionaries[type])
      }).catch((err) => {
        console.log(err)
      })
    }
  }
  // console.log(tempDictionaries)
  sessionStorage.removeItem('dictionaries')
  sessionStorage.setItem('dictionaries', JSON.stringify(tempDictionaries))
  return tempDictionaries
}


/**
 * 将 ISO 8601 时间字符串转换为 YYYY-MM-DD HH:MM:SS 格式
 * @param {string} isoTime - ISO 8601 时间字符串
 * @returns {string} - 格式化后的时间字符串
 */
export function formatIOSTime(isoTime) {
  if (!isoTime) return '';
  const date = new Date(isoTime);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

/**
 *  判断是否是移动端
 * 
 * 
 */
export function isMobile(){
  const userAgent = window.navigator.userAgent;
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|mobile/i.test(userAgent);
}

